import { Controller } from "@hotwired/stimulus"

// Abre o modal ÚNICO de detalhe de notificação carregando o conteúdo sob demanda.
// Vive no mesmo elemento que o dialog controller (ver _notification_modal).
//
// Qualquer elemento com `data-notification-url="<show path>"` na página, ao ser
// clicado, faz: (1) seta o src do turbo-frame "notification-detail" pra aquela
// URL (carrega o detalhe via show, que também marca como visto), (2) abre o
// dialog. Funciona pro sino e pras listagens (público e admin) — a URL já vem
// no contexto certo (admin_inbox / notifications).
//
//   <li data-notification-url="<%= notification_path(delivery) %>">…</li>
export default class extends Controller {
  connect() {
    this.frame = this.element.querySelector("#notification-detail")
    this.dialog = this.application.getControllerForElementAndIdentifier(this.element, "dialog")
    this.boundClick = (e) => this.onClick(e)
    this.boundKeydown = (e) => this.onKeydown(e)
    document.addEventListener("click", this.boundClick)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClick)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  // Itens da lista são <div role="button" tabindex="0"> (não <button> nativo, pq
  // contêm forms de ação dentro). Enter/Space precisam abrir o modal via teclado.
  onKeydown(e) {
    if (e.key !== "Enter" && e.key !== " ") return
    const item = e.target.closest("[data-notification-url]")
    if (!item || item.tagName === "BUTTON" || item.tagName === "A") return // nativos já tratam
    if (e.target.closest("[data-notification-skip-modal]")) return
    e.preventDefault()
    this.onClick(e)
  }

  onClick(e) {
    // 1) Clique no botão "Acessar" DENTRO do modal: fecha o modal ANTES de o link
    //    seguir. Sem isso, o modal (focus trap + overflow:hidden) fica por cima e
    //    bloqueia: externo → o dialog de confirmação não recebe interação (trava);
    //    interno → navegaria preso. Não damos preventDefault — o link segue
    //    naturalmente (externo: external_link_controller abre nova aba; interno:
    //    target=_top navega a página). Só removemos o trap antes.
    if (e.target.closest("[data-notification-open-link]")) {
      // closeNow (síncrono) remove o focus trap + overflow IMEDIATAMENTE, antes do
      // link seguir — senão o trap deste modal bloquearia o dialog de confirmação
      // de link externo (ou prenderia a navegação interna). Sem preventDefault: o
      // link segue (externo → external_link_controller abre nova aba; interno → _top).
      this.dialog?.closeNow()
      return
    }

    // 2) Clique num item de notificação (lista/sino): abre o modal com o detalhe.
    const trigger = e.target.closest("[data-notification-url]")
    if (!trigger) return
    // Ignora as AÇÕES RÁPIDAS internas (✓ marcar / 🗑 remover): têm seus forms.
    if (e.target.closest("[data-notification-skip-modal]")) return

    e.preventDefault()
    const url = trigger.getAttribute("data-notification-url")
    if (!this.frame || !this.dialog) return

    // Recarrega o frame mesmo se a mesma URL foi setada antes (reabrir a mesma).
    this.frame.removeAttribute("complete")
    this.frame.setAttribute("src", url)
    this.dialog.open()
  }
}
